import React from 'react';

export default function QuickReplies({ options, onSelect, disabled }) {
  if (!options?.length) return null;
  return (
    <div className="sa-quick-replies" role="group" aria-label="Risposte rapide">
      {options.map((opt) => (
        <button
          key={opt.id}
          type="button"
          className="sa-quick-reply-btn"
          disabled={disabled}
          onClick={() => onSelect(opt)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
